export const ar = {
  pages: {
    confirmationNeeded: "تحتاج تأكيد",
    checkoutRecovery: "استرداد السلة",
    openDraftOrders: "طلبات مسودة مفتوحة",
    mySnoozed: "المؤجلة لدي",
    myArchived: "المؤرشفة لدي",
    unassigned: "غير معيّنة",
    needsAttention: "تحتاج اهتمام",
  },
  disable: {
    title: "تعطيل {{name}}؟",
    description: "سيتم تعطيل هذا المحفز. ستظل جميع المهام السابقة مرئية، ولكن من هذه النقطة فصاعدًا، لن تتم مزامنة أي مهام جديدة من متجر العملاء.",
    disabling: "جارٍ التعطيل...",
    confirm: "نعم، تعطيل المحفز",
  },
  history: {
    action: { enabled: "تم التشغيل", disabled: "تم الإيقاف", updated: "تم التغيير" },
    value: { nothing: "لا شيء", on: "تشغيل", off: "إيقاف" },
    changesCount_one: "تغيير {{count}}",
    changesCount_other: "{{count}} تغييرات",
    empty: {
      title: "لا يوجد نشاط بعد",
      description: "عند تشغيل القواعد أو تغييرها أو إيقافها، ستظهر التفاصيل هنا.",
    },
    filters: {
      activityAll: "الكل",
      activityLabel: "المهمة",
      ruleAll: "كل القواعد",
      ruleLabel: "القاعدة",
    },
    fields: {
      enabled: "الحالة",
      sync_tag: "وسم المزامنة",
      conditions: {
        payment_method: "طرق الدفع",
        min_order_value: "الحد الأدنى لقيمة الطلب",
        include_tags: "تضمين الوسوم",
        exclude_tags: "استبعاد الوسوم",
        order_source: "مصدر الطلب",
        min_draft_age_hours: "الحد الأدنى لعمر المسودة",
        min_draft_value: "الحد الأدنى لقيمة المسودة",
        require_phone: "يتطلب هاتفًا",
        min_checkout_value: "الحد الأدنى لقيمة السلة",
        include_customer_tags: "تضمين وسوم العميل",
        exclude_customer_tags: "استبعاد وسوم العميل",
        checkout_source: "مصدر السلة",
        customer_entered_phone: "هاتف العميل المُدخل",
        checkout_step_reached: "خطوة الدفع الموصولة",
        returning_customer_only: "العملاء العائدون فقط",
      },
      assignment: {
        team_id: "الفريق",
        default_owner_id: "تعيين إلى",
        priority: "الأولوية",
      },
    },
  },
  onboarding: {
    title: "دليل الإعداد",
    dismissAriaLabel: "إغلاق دليل الإعداد",
    loadingProgress: "جارٍ تحميل تقدم الإعداد...",
    tasksCompleted: "{{completed}} من {{total}} مهام مكتملة",
    description: "أكمل هذه الخطوات لتجهيز OrderHub لفريقك.",
    goToSetup: "اذهب إلى الإعداد",
    finishing: "جارٍ الإنهاء...",
    finishSetup: "إنهاء الإعداد",
    steps: {
      "connect-shopify": {
        title: "ربط Shopify",
        description: "اربط متجر Shopify الخاص بك وفعّل مزامنة البيانات.",
      },
      "configure-triggers": {
        title: "تهيئة المحفّزات",
        description: "إعداد التأكيد المطلوب، الطلبات المسودة المفتوحة، واسترداد السلة.",
      },
      "invite-users": {
        title: "ادعُ فريقك",
        description: "أضف أعضاء الفريق للتعاون في الطلبات.",
      },
    },
  },
  help: {
    backToBilling: "← العودة إلى الاشتراك",
    title: "اتصل بنا",
    subtitle: "تحتاج إلى أكثر من 15 مستخدمًا أو لديك سؤال حول الاشتراك؟ أرسل لنا رسالة وسنعاود الاتصال بك.",
    success: {
      heading: "تم إرسال الرسالة!",
      body: "شكرًا لتواصلك معنا. سيعود فريقنا إليك خلال 24 ساعة.",
      sendAnother: "إرسال رسالة أخرى",
    },
    form: {
      namePlaceholder: "اسمك",
      emailPlaceholder: "you@example.com",
      subjectLabel: "الموضوع",
      subjectPlaceholderOption: "اختر موضوعًا",
      subjectEnterprise: "خطة المؤسسات (15+ مستخدم)",
      subjectBilling: "سؤال الاشتراك",
      subjectUpgrade: "مساعدة ترقية الخطة",
      subjectOther: "أخرى",
      messageLabel: "الرسالة",
      messagePlaceholder: "أخبرنا كيف يمكننا المساعدة...",
      sendButton: "إرسال الرسالة",
      placeholderNotice: "هذا نموذج مؤقت. سيتم إضافة تكامل HelpScout قريبًا.",
    },
  },
  userLimitBanner: {
    message: "لدى مساحة عملك {{current}} مستخدم نشط ولكن خطتك تسمح بـ {{limit}}. يتم حظر تخفيض الخطة حتى تتم إزالة المستخدمين الزائدين. سيتم إلغاء تنشيط المستخدمين الزائدين إذا تأخرت الاشتراك.",
    manageUsers: "إدارة المستخدمين",
  },
  featureGate: {
    upgradePrompt: "قم بالترقية إلى خطة {{plan}} لفتح {{feature}}",
  },
  names: {
    confirmation_needed: "تحتاج تأكيد",
    open_draft_orders: "طلبات مسودة مفتوحة",
    checkout_recovery: "استرداد السلة",
  },
  descriptions: {
    confirmation_needed: "يُحفّز عندما يتطلب طلب الدفع عند الاستلام أو طريقة دفع معينة تأكيدًا هاتفيًا",
    open_draft_orders: "يُحفّز عندما تبقى المسودة مفتوحة لفترة تتجاوز حدًا زمنيًا معينًا",
    checkout_recovery: "يُحفّز عندما تفي السلة المتروكة بمعايير القيمة والهاتف",
  },
} as const;
